const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="512"
      height="512"
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        fill="#000"
        d="M254.237 48A208.038 208.038 0 0050 256a208.036 208.036 0 00204.237 208c114.851 0 208-93.149 208-208s-93.149-208-208-208zm-6.517 329.333a21.663 21.663 0 01-21.667-21.666 21.667 21.667 0 1121.667 21.666zm36.226-110.482c-17.541 11.786-19.968 22.533-19.968 32.482a15.182 15.182 0 01-25.643 10.265 15.183 15.183 0 01-4.69-10.265c0-23.712 10.92-42.64 33.384-57.72 20.904-14.005 32.725-22.88 32.725-42.432 0-13.242-7.626-23.33-23.296-30.784-3.709-1.768-11.925-3.501-22.048-3.397-12.688.173-22.533 3.224-30.16 9.36-14.282 11.509-15.496 24.059-15.496 24.232a15.204 15.204 0 01-15.929 14.439 15.204 15.204 0 01-14.439-15.93c.139-2.6 1.942-26.346 26.832-46.349 12.931-10.4 29.328-15.773 48.742-16.016 13.797-.173 26.693 2.184 35.464 6.309 26.242 12.411 40.664 33.072 40.664 58.136 0 36.678-24.51 53.144-46.107 67.67h-.035z"
      ></path>
    </svg>
  );
};

export default InfoIcon;
